var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.75H12.25C12.5722 1.75 12.8333 2.01117 12.8333 2.33333V11.6667C12.8333 11.9888 12.5722 12.25 12.25 12.25H1.75C1.42783 12.25 1.16666 11.9888 1.16666 11.6667V2.33333C1.16666 2.01117 1.42783 1.75 1.75 1.75ZM11.6667 4.22212L7.04188 8.36383L2.33333 4.2093V11.0833H11.6667V4.22212ZM2.63168 2.91667L7.03611 6.80283L11.3756 2.91667H2.63168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.79bf1333fe5aa4c09bc50a8ce9731267.svg";
export { ForwardRef as ReactComponent };